module.exports = __webpack_public_path__ + "static/main_text-60841cfc4412f65fb6cd05261a2ea668.png";